// 弹窗队列选择器 hooks（§5）
import { useShallow } from 'zustand/react/shallow';

import { useActivityQueueStore } from './slice';

/** 当前展示中的任务（PopupHost 订阅） */
export const useActivityCurrent = () => useActivityQueueStore(state => state.current);

/** 等待队列 */
export const useActivityWaiting = () => useActivityQueueStore(state => state.waiting);

/** 本轮已展示计数 */
export const useActivityEntryCount = () => useActivityQueueStore(state => state.entryCount);

/** 可信 activeScene（§5.2.1） */
export const useActiveScene = () => useActivityQueueStore(state => state.activeScene);

/** 到墙 offer 拉取是否已落地（成功 / 失败 / 超时均算落地）；付费墙商品卡展示门禁用 */
export const usePaywallOfferSettled = () => useActivityQueueStore(state => state.paywallOfferStatus === 'settled');

/** 队列动作集合 */
export const useActivityQueueActions = () =>
    useActivityQueueStore(
        useShallow(state => ({
            enqueue: state.enqueue,
            tryShow: state.tryShow,
            onScene: state.onScene,
            dismiss: state.dismiss,
            purgeActivityTasks: state.purgeActivityTasks,
            setMaxPerEntry: state.setMaxPerEntry,
            resetEntry: state.resetEntry,
            setActiveScene: state.setActiveScene,
            reset: state.reset,
        }))
    );
